module.exports = __webpack_public_path__ + "img/banner.554c3fd9.png";